export const terms = [
	{
		title: "Account information",
		body: "Provide accurate account and delivery information so we can process your orders and contact you when support is needed.",
	},
	{
		title: "Orders and availability",
		body: "Product prices and stock are confirmed during checkout. An item may become unavailable before an order is completed.",
	},
	{
		title: "Order cancellation",
		body: "Orders can be cancelled from My Orders while they are still awaiting payment. Processing, shipped or completed orders cannot be cancelled there.",
	},
	{
		title: "Shipping and delivery",
		body: "Delivery estimates depend on the selected method and destination. Delays outside Techanor’s control may occasionally occur.",
	},
	{
		title: "Returns and support",
		body: "If an item arrives damaged, incorrect or incomplete, contact Techanor Support with your order details so the issue can be reviewed.",
	},
	{
		title: "Responsible use",
		body: "Do not misuse the website, attempt unauthorized access or provide fraudulent payment, account or delivery information.",
	},
];
